// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/
.custom-access-header .customHeaderLabel {
  font-family: "72-Regular";
}

.custom-access-header .customHeaderLabel {
  font-size: 1.2rem;
  text-align: left;
  color: #6a6d70;
  text-transform: capitalize;
  font-weight: normal;
}
.custom-access-header .icon-sort-ascending,
.custom-access-header .icon-sort-descending {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.custom-access-header .access-levels {
  width: 590px;
}
.custom-access-header .access-level .close-icon {
  color: #fff;
  border-radius: 10rem 0rem 0rem 10rem;
  background: #7ecde8;
  text-align: center;
  height: 2.4rem;
  overflow: hidden;
  font-size: 1.6rem;
  display: inline-table;
  margin-left: -1.1rem;
  width: 2.1rem;
}
.custom-access-header .access-level .close-icon:hover {
  background-color: #42aed8;
}
.custom-access-header .access-level .close-icon img {
  margin-top: 0.3rem;
  width: 1rem;
  height: 1rem;
  margin-left: 0.3rem;
}
.custom-access-header .access-level:not(.active) .filter-name:hover:after {
  font-family: "SAP-icons";
  font-style: normal;
  speak: none;
  color: #bd10e0;
  content: "\\e076";
  margin-left: 5px;
  font-weight: normal;
}
.custom-access-header .access-level.active {
  position: relative;
  padding: 0 1rem;
  display: inline-block;
  border-radius: 10rem;
  background-color: #ffffff;
  border: solid 0.1rem #7ecde8;
  cursor: pointer;
  color: #4a4a4a;
  line-height: 1.8rem;
}
.custom-access-header .access-level.active:hover {
  background-color: #eff9fc;
}
.custom-access-header .access-level.active .filter-name {
  font-size: 1.1rem;
  color: #4a4a4a;
}
.custom-access-header .sort-icons:before {
  font-size: 1.8rem;
}
.custom-access-header .alp-sort-icon {
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/css/fonts.scss","webpack://./src/app/components/administration/users/permissions-custom-header/permissions-custom-header.component.scss"],"names":[],"mappings":"AAIA,gHAAA;AAqBA;EACI,yBAAA;ACvBJ;;AADI;EACI,iBAAA;EAEA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,mBAAA;AAGR;AADI;;EAEI,oBAAA;EACA,qBAAA;AAGR;AADI;EACI,YAAA;AAGR;AAAQ;EACI,WAAA;EACA,oCAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,oBAAA;EACA,aAAA;AAEZ;AADY;EACI,yBAAA;AAGhB;AADY;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAGhB;AAEgB;EACI,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAApB;AAIQ;EACI,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,yBAAA;EACA,4BAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAFZ;AAGY;EACI,yBAAA;AADhB;AAGY;EACI,iBAAA;EACA,cAAA;AADhB;AAMQ;EACI,iBAAA;AAJZ;AAOI;EACI,eAAA;AALR","sourcesContent":["%font-black{\n    font-family: '72-Black';\n}\n\n/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/\n// %font-bold{\n//     font-family: '72-Bold';\n// }\n\n// %font-condensed-bold{\n//     font-family: '72-CondensedBold';\n// }\n\n// %font-bold-italic{\n//     font-family: '72-BoldItalic';\n// }\n\n%font-condensed{\n    font-family: '72-Condensed';\n}\n\n%font-italic{\n    font-family: '72-Italic';\n}\n\n%font-regular{\n    font-family: '72-Regular';\n}\n\n%font-light{\n    font-family: '72-Light';\n}\n\n@import '_variables';","@import '../../../../assets/css/fonts';\n.custom-access-header{\n    .customHeaderLabel{\n        font-size: 1.2rem;\n        @extend %font-regular;\n        text-align: left;\n        color: #6a6d70;\n        text-transform: capitalize;\n        font-weight: normal;\n    }\n    .icon-sort-ascending,\n    .icon-sort-descending{\n        padding-left: 0.5rem;\n        padding-right: 0.5rem;\n    }\n    .access-levels {\n        width: 590px;\n    }\n    .access-level{\n        .close-icon {\n            color: #fff;\n            border-radius: 10rem 0rem 0rem 10rem;\n            background: #7ecde8;\n            text-align: center;\n            height: 2.4rem;\n            overflow: hidden;\n            font-size: 1.6rem;\n            display: inline-table;\n            margin-left: -1.1rem;\n            width: 2.1rem;\n            &:hover {\n                background-color: #42aed8;\n            }\n            img {\n                margin-top: 0.3rem;\n                width: 1rem;\n                height: 1rem;\n                margin-left: 0.3rem;\n            }\n        }\n        &:not(.active){\n            .filter-name:hover{\n                &:after{\n                    font-family: 'SAP-icons';\n                    font-style: normal;\n                    speak: none;\n                    color: #bd10e0;\n                    content: \"\\e076\";\n                    margin-left: 5px;\n                    font-weight: normal;\n                }\n            }\n        }\n        &.active{\n            position: relative;\n            padding: 0 1rem;\n            display: inline-block;\n            border-radius: 10rem;\n            background-color: #ffffff;\n            border: solid 0.1rem #7ecde8;\n            cursor: pointer;\n            color: #4a4a4a;\n            line-height:1.8rem;\n            &:hover {\n                background-color: #eff9fc;\n            }\n            .filter-name {\n                font-size: 1.1rem;\n                color: #4a4a4a;\n            }\n        }\n    }\n    .sort-icons{\n        &:before{\n            font-size: 1.8rem;\n        }\n    }\n    .alp-sort-icon {\n        font-size: 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
